import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const ManuelSevkEmri = () => {
    return (
        <>
            {/* sase	bayi_adi	sevkiyat_notu	teslim_alan */}
            <ExcelUpload
                role_name="manuel_sevk_write"
                requiredColumnsSase={[
                    "sase", "bayi_adi", "sevkiyat_notu", "teslim_alan"
                ]}
                process_type="MANUAL_SHIPPING"
                ExcelName={"Hatalı Sevk Verileri"}
                Title={"Manuel Sevk Emri"}
                exampleData={[
                    {
                        sase: "VR3USHNS7RJ793212",
                        bayi_adi: "AĞAÇLI",
                        sevkiyat_notu: "NOT",
                        teslim_alan: ""
                    }
                ]}
            />
        </>
    )
}

export default ManuelSevkEmri